<template>
  <div class="buy-dialog">
    <div class="buy-dialog__container">
      <div class="buy-dialog__top">
        <span class="buy-dialog__title">
          联报
        </span>
        <span class="buy-dialog__close" @click="handleClose"
          ><i class="iconfont1 icon-guanbi"></i
        ></span>
      </div>
      <div class="dialog-content">
        <div class="dialog-content__purchase">
          <div class="purchase__title">
            已报课程
          </div>
          <div class="purchase__card">
            <buy-dialog-card :data="courseDetail"></buy-dialog-card>
          </div>
        </div>
        <div class="dialog-content__unite">
          <div class="unite__title">
            {{ courseDetail.courseResale.unionTitle }}
          </div>
          <div class="unite__card">
            <buy-dialog-card
              :data="computedUniteCourse"
              :isUnite="true"
              @chooseCourse="hasChoose"
            ></buy-dialog-card>
          </div>
        </div>
      </div>
      <div class="buy-dialog__footer">
        <div class="buy-dialog__footer__left">
          <p class="buy-dialog__sum">
            合计：<span class="buy-dialog__price">¥{{ sumPrice }}</span>
          </p>
          <p class="buy-dialog__text" v-if="chooseUnite">已选择联报</p>
        </div>
        <div class="buy-dialog__btn" v-if="isAddCartDialog" @click="handleDialogAddCart">
          <div class="buy-dialog__btn__text">加入购物车</div>
          <div class="buy-dialog__btn__ball" ref="myCartBall">购</div>
        </div>
        <div v-else class="buy-dialog__btn" @click="handleBuyReCourse($event)">
          {{ chooseUnite ? '立即联报' : '单独报名' }}
        </div>
      </div>
    </div>
    <div class="buy-dialog__shadow" v-show="isPopup"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import types from '@/views/CourseDetail/store/types'
import BuyDialogCard from './BuyDialogCard'
import ballAnimation from '@/util/ballAnimation'

export default {
  name: 'buy-dialog',
  props: ['isAddCartDialog'],
  mixins: [ballAnimation],
  data() {
    return {
      isPopup: true,
      chooseUnite: true
    }
  },
  components: {
    BuyDialogCard
  },
  computed: {
    ...mapState({
      courseDetail: state => state.CourseDetail.courseDetail,
      addCartResult: state => state.CourseDetail.addCartResult
    }),
    computedUniteCourse() {
      return {
        subjects: this.courseDetail.subjects,
        name: this.courseDetail.courseResale.unionCourses.name,
        price: {
          resale: this.courseDetail.courseResale.unionCourses.resale,
          origin: this.courseDetail.courseResale.unionCourses.price
        },
        syllabusNum: this.courseDetail.courseResale.unionCourses.syllabusNum,
        schoolTimeName: this.courseDetail.courseResale.unionCourses.courseTime,
        chineseTeacher: this.courseDetail.courseResale.unionCourses.teacherInfos.china,
        foreignTeacher: this.courseDetail.courseResale.unionCourses.teacherInfos.foreign,
        isHaveCounselorTeacher:
          this.courseDetail.courseResale.unionCourses.counselor.length > 0 ? 1 : 0,
        class: {
          counselor:
            this.courseDetail.courseResale.unionCourses.counselor.length > 0
              ? this.courseDetail.courseResale.unionCourses.counselor[0]
              : {}
        }
      }
    },
    sumPrice() {
      if (this.chooseUnite) {
        return this.courseDetail.courseResale.unionResale
      }
      return this.courseDetail.price.resale
    },
    url() {
      return !this.chooseUnite
        ? `https://trade.xueersi.com/Web/Order/confirm?idEncode=${this.courseDetail.idEncode}`
        : `https://trade.xueersi.com/Web/Order/confirm?idEncode=${this.courseDetail.unionIdEncode}`
    }
  },
  methods: {
    ...mapActions({
      getAddCart: types.GET_ADD_CART
    }),
    // 点击加入购物车
    async handleDialogAddCart() {
      // 调接口
      let productCourse = {
        productId: this.courseDetail.id,
        classId: this.courseDetail.class.id || 0,
        parentProductId: 0
      }
      let params = [productCourse]
      if (this.chooseUnite) {
        productCourse.promotionId =
          this.courseDetail.courseResale.unionCourses.promotionId || 0
        productCourse.promotionType = 3
        const unionCourse = {
          productId: this.courseDetail.courseResale.unionCourses.courseId,
          classId: this.courseDetail.courseResale.unionCourses.classId || 0,
          parentProductId: this.courseDetail.id,
          promotionId: this.courseDetail.courseResale.unionCourses.promotionId || 0,
          promotionType: 3
        }
        params = [productCourse, unionCourse]
      }
      await this.getAddCart(params)
      if (Number(this.addCartResult.status) !== 0) {
        this.handleClose()
        if (Number(this.addCartResult.type) === 3) {
          this.$emit('openShoppingToast')
        } else {
          this.$emit('openShoppingDailog')
        }
      } else {
        // 加入成功关闭弹窗
        this.addCartAni('myCartBall')
        setTimeout(() => {
          this.handleClose()
        }, 1000)
      }
    },
    handleBuyReCourse(event) {
      window.location.href = this.url
      const XESLog = new this.$XESLog({
        key: 'xeslog-click-buyresalecourse',
        courseid: this.courseDetail.id,
        clickid: '1.8.4',
        clickurl: this.url,
        classid: this.courseDetail.class.id,
        subjectid: this.courseDetail.subjects[0].id,
        gradeid: this.courseDetail.grades
          ? this.courseDetail.grades
              .filter(item => item)
              .map(item => item.id)
              .join(',')
          : '',
        promotionid: this.courseDetail.courseResale.promotionId || 0,
        recourseid: this.courseDetail.courseResale.unionCourses.courseId,
        btnstate: this.courseDetail.saleStatus.statusDesc,
        coursetype: this.courseDetail.courseType
      })
      XESLog.push({ eventname: 'click', target: event.target }, this.$route)
    },
    hidePopup() {
      this.isPopup = !this.isPopup
    },
    hasChoose(val) {
      this.chooseUnite = val
    },
    handleClose() {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(buy-dialog) {
  @include e(shadow) {
    display: block;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 199;
  }
  @include e(container) {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 999;
    border-radius: 4px;
    transform: translate(-50%, -50%);
    background: #fff;
    width: 800px;
  }
  @include e(top) {
    box-sizing: border-box;
    height: 54px;
    // width: 800px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(245, 245, 245, 1);
    border-radius: 2px 2px 0px 0px;
  }
  @include e(title) {
    color: #666666;
    font-size: 14px;
  }
  @include e(close) {
    & > i {
      font-size: 14px;
      color: #999999;
      cursor: pointer;
      &:hover {
        color: #333;
      }
    }
  }
  @include e(footer) {
    display: flex;
    justify-content: flex-end;
    justify-items: center;
    padding: 20px 32px;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0px -1px 0px 0px rgba(229, 229, 229, 1);
    border-radius: 0px 0px 2px 2px;
    margin-top: 44px;
    @include e(left) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      justify-items: center;
      margin-right: 20px;
    }
  }
  @include e(text) {
    color: #999999;
    font-size: 12px;
    text-align: right;
    margin-top: 8px;
  }
  @include e(btn) {
    position: relative;
    width: 144px;
    height: 40px;
    background: rgba(241, 50, 50, 1);
    border-radius: 2px;
    text-align: center;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(255, 255, 255, 1);
    line-height: 40px;
    cursor: pointer;
    @include e(ball) {
      visibility: hidden;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 16px;
      width: 16px;
      font-size: 12px;
      line-height: 16px;
      border-radius: 50%;
      background-color: rgba(241, 50, 50, 0.1);
      color: #f13232;
      z-index: 9999;
    }
  }
  @include e(price) {
    color: #f13232;
    font-size: 16px;
  }
  @include e(sum) {
    color: #333333;
    font-size: 14px;
  }
}
@include b(dialog-content) {
  padding: 0 32px;
  & > div {
    margin-top: 32px;
  }
}
.purchase__title,
.unite__title {
  color: #333333;
  font-size: 15px;
  height: 16px;
  font-weight: 600;
}
.purchase__card,
.unite__card {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/BuyDialog.vue